import {nextArrow, prevArrow} from '../components/slick-arrow';
import disabledNextArrow from '../common/disabledNextArrow';
import BreakpointsEnum from '../enums/breakpointsEnum';

$(function () {
    let App = window.App;
    App.tagsSlider = {};

    App.tagsSlider.initSlider = function () {
        let $tagsSlider = $('.tags-container .slider');

        disabledNextArrow($tagsSlider);

        $tagsSlider.slick({
            slidesToScroll: 5,
            arrows: true,
            focusOnSelect: true,
            dots: false,
            infinite: false,
            nextArrow: nextArrow(),
            prevArrow: prevArrow(),
            variableWidth: true,
            speed: 300,
            rows: 0,
            swipe: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: 'unslick'
                }
            ]
        });
    }

    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        App.tagsSlider.initSlider();
    }

    $(window).resize(function () {
        let $tagsSlider = $('.tags-container .slider');

        if ($tagsSlider.length && !$tagsSlider.hasClass('slick-initialized') &&
            [BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
            App.tagsSlider.initSlider();
        }
    });
});